const ENUsers = {
	"Adicionar usuário": "Add user",
	"Adicionar grupo de usuário": "Add user group",
	"As senhas não conferem": "Passwords did not match",
	"Alterar Responsável/Autoridade": "Change Responsible/Authority",
	"Alterar senha no próximo acesso": "Change password on next login",
	"Convite": "Invite",
	"Convite aceito": "Invite accepted",
	"Convites": "Invites",
	"Convidar usuários": "Invite users",
	"Convites enviados com sucesso": "Invitations sent successfully",
	"Convite já existe para o email": "Invite already exists to this email",
	"Convite removido com sucesso": "Invitation removed successfully",
	"Criado em": "Created in",
	"Data de envio": "Send date",
	"Desabilitar usuário": "Disable user",
	"Desabilitar o usuário": "Disable user",
	"Dias para expirar a senha deve conter no máximo 5 caracteres": "Days to expire password must contain a maximum of 5 characters",
	"desse grupo empresa": "from this company group",
	"Deseja realmente desabilitar o usuário": "Do you really want to disable the user",
	"Deseja realmente excluir o convite para o email": "Do you really want to delete the email invite",
	"Deseja realmente excluir o usuário": "Do you really want to delete the user",
	"Deseja realmente restaurar o acesso do usuário": "Do you really want to restore user access",
	"Deve conter 8 caracteres, um maiúsculo, um minúsculo, um número e um caractere especial": "Must contain 8 characters, an uppercase, a lowercase, a number and a special character",
	"Dias para expirar a senha": "Days to expire password",
	"Empresa é requerido": "Company is required",
	"Empresas não podem ser repetidas": "Companies cannot be repeated",
	"É necessario preencher ao menos um convite": "It is nedded to fill at least one invitation",
	"É necessario preencher ao menos uma empresa": "It is nedded to fill at least one company",
	"É necessario preencher ao menos um grupo de usuários": "It is nedded to fill at least one users group",
	"Email é requerido": "Email is required",
	"Email inválido": "Invalid email",
	"Email não podem ser repetidos": "Email cannot be repeated",
	"Erro ao aceitar convite": "Error accepting invitation",
	"Erro ao ler o arquivo": "Error reading the file",
	"Erro ao buscar informações para manutenção do usuário": "Error fetching information for user maintenance",
	"Erro ao desabilitar usuário do grupo empresa": "Error disabling user from company group",
	"Erro ao efetuar manutenção do usuário": "Error performing user maintenance",
	"Erro ao enviar convites": "Error sending invites",
	"Erro ao excluir usuário do grupo empresa": "Error deleting user from company group",
	"Erro ao registrar usuário": "Error registering user",
	"Erro ao remover convite do dashboard": "Error removing invite from dashboard",
	"Erro ao restaurar usuário do grupo empresa": "Error restoring user from company group",
	"Erro ao alterar responsáveis e autoridades": "Error updating responsible and authorities",
	"Esse convite está inválido": "This invitation is invalid",
	"Esse convite não é para o seu usuário": "This invitation is not for your user",
	"Exclusão de convite": "Invitation deletion",
	"Exclusão de usuário": "User deletion",
	"Grupo de usuários é requerido": "Users group is required",
	"Gerar senha aleatória": "Generate random password",
	"Habilitar usuário": "Enable user",
	"Importar usuários": "Import users",
	"Insira ao menos um convite": "Insert at least one invite",
	"Insira ao menos um grupo de usuário": "Insert at least one user's group",
	"Insira ao menos uma empresa": "Insert at least one company",
	"Logue-se na aplicação para acessar o convite": "Log into the application to access the invitation",
	"Manutenção do usuário efetuada com sucesso": "Successful user maintenance",
	"Mostrar apenas habilitados": "Show only enabled",
	"Nenhuma empresa adicionada": "No company added",
	"Nenhum usuário adicionado": "No users added",
	"Novo usuário": "New user",
	"Nenhum grupo de usuário adicionado": "No users group added",
	"no grupo empresarial": "in the business group",
	"Nome é necessário": "Name is required",
	"Número de usuários excede a quantidade máxima do contrato": "Number of users exceeds the maximum contract amount",
	"Número de usuários habilitados cadastrados": "Number of registered enabled users",
	"Pendente validação do email": "Pending email validation",
	"Por favor, selecione um usuário diferente do atual": "Please select a different user than the current one",
	"Responsáveis e autoridades alterados com sucesso": "Responsible and authorities successfully changed",
	"O link desse convite está inválido": "The link for this invite is invalid",
	"Responsáveis alterados com sucesso": "Responsible successfully changed",
	"Autoridades alteradas com sucesso": "Authorities successfully changed",
	"Erro ao alterar responsáveis": "Error updating responsible",
	"Erro ao alterar autoridades": "Error updating authorities",
	"Senha deve ter no mínimo 8 dígitos": "Password must be at least 8 digits long",
	"Usuário desabilitado com sucesso do grupo empresa": "User successfully disabled from the company group",
	"Usuário excluído com sucesso do grupo empresa": "User successfully deleted from the company group",
	"Usuário restaurado com sucesso do grupo empresa": "User successfully restored from the company group",
	"Usuário já está adicionado": "User already added",
	"Usuário registrado com sucesso": "User successfully registered",
	"Utilize arquivos no formato .txt ou .csv. O arquivo deve conter os e-mails dos usuários separados por uma quebra de linha": "Use files in .txt or .csv format. The file must contain users e-mails separated by a break line",
	"Validar IP de acesso": "Validate access IP",
	"Você está tentando se registrar com um email diferente do permitido para esse convite": "You are trying to register with a different email than allowed for this invite",
	"Você foi convidado para participar do grupo": "You have been invited to join the group",
	"Você pode remover a autenticação em dois fatores clicando sobre o botão abaixo": "You can remove two factor authentication by clicking on the button below",
	"Visualize os resultados na aba de dados gerais": "View the results in the general data tab"
};

export default ENUsers;
